// Load the BPE vocab (one token per line). Token 0..N-1 maps directly to row in vocab.txt.

// SentencePiece word-boundary marker (U+2581 LOWER ONE EIGHTH BLOCK).
const SP_WORD_BOUNDARY = "\u2581";

export async function loadVocab(url) {
  const resp = await fetch(url);
  if (!resp.ok) throw new Error(`Vocab fetch failed: ${url} (${resp.status})`);
  const text = await resp.text();
  // CRLF tolerance: vocab.txt is auto-checked-out as LF on macOS/Linux,
  // but a Windows dev with core.autocrlf=true would otherwise leave a
  // trailing \r on every token, shifting CTC argmax IDs.
  const tokens = text.split(/\r?\n/);
  if (tokens[tokens.length - 1] === "") tokens.pop();
  return tokens;
}

export function detokenize(vocab, ids) {
  let out = "";
  for (let i = 0; i < ids.length; i += 1) out += vocab[ids[i]] || "";
  return out.replaceAll(SP_WORD_BOUNDARY, " ").trim();
}
